import Swiper from "swiper/bundle";

const Slider = () => {
  const sliders = Array.from(document.querySelectorAll(".example-slider"));
  if (sliders.length > 0) {
    sliders.forEach((slider) => {
      const initSlider = new Swiper(slider, {
        loop: true,
        spaceBetween: 16,
        slidesPerView: 1,
        lazy: {
          loadPrevNext: true,
        },
        pagination: {
          el: slider.querySelector(".slider__pagination"),
          clickable: true,
        },
        navigation: {
          nextEl: slider.querySelector(".slider__next-btn"),
          prevEl: slider.querySelector(".slider__prev-btn"),
        },
        breakpoints: {
          767: {
            slidesPerView: 2,
          },
          1023: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        },
      });
    });
  }
};

export default Slider;
